export default __webpack_public_path__ + "static/media/masters.20fcba97.jpg";